<mat-toolbar>
  <div class="container-fluid content-container">
    <div class="content-container">
      <mat-card>
        <mat-card-content>
          <div class="header-container">
            <div class="header-text">
              <i class="material-icons-outlined" >{{helperService.icon}}</i>
              <span> {{ helperService.TitlePage | translate }} </span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <span class="spacer"></span>
  <p class="profile-name">
    {{ userProfile?.firstName | titlecase }}
    {{ userProfile?.lastName | titlecase }}
  </p>
  <div class="profile-picture-container">
    <div class="initials-icon">
      <p class="initials">
        {{ userProfile?.firstName?.charAt(0)
        }}{{ userProfile?.lastName?.charAt(0) }}
      </p>
    </div>
  </div>
</mat-toolbar>

